import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router';
import A11y from 'chameleon/ui-stack/utilities/a11y';
import {
  getResourceAddress,
  getSignedUnitResource,
  getValidBucketUrl,
  isS3Resource,
} from 'chameleon-src/utility/signedUrl';

const SignedLink = ({
  isSigned,
  url,
  children,
  useClassroomResourceAddress,
  params,
  ...rest
}) => {
  const [signedUrl, setSignedUrl] = useState(url);

  const { subject: subjectId } = params;
  useEffect(() => {
    if (!isSigned && !useClassroomResourceAddress && isS3Resource(url)) {
      const urlBucket = getValidBucketUrl(url);
      if (urlBucket) {
        getSignedUnitResource(url).then((signedResourceURL) => {
          setSignedUrl(signedResourceURL);
        });
      }
    }
  }, [url]);

  useEffect(() => {
    if (useClassroomResourceAddress) {
      if (isS3Resource(url)) {
        setSignedUrl(getResourceAddress(url, subjectId));
      }
    }
  }, [url]);

  return (
    <A11y>
      <Link
        data-test-subunit-url
        disabled={!signedUrl}
        to={signedUrl}
        target="_blank"
        {...rest}
      >
        {children}
      </Link>
    </A11y>
  );
};

SignedLink.propTypes = {
  url: PropTypes.string.isRequired,
  isSigned: PropTypes.bool,
};

SignedLink.defaultProps = {
  isSigned: false,
  useClassroomResourceAddress: false,
};

export default withRouter(SignedLink);
